<template>
    <div class="modal hide fade in" id="modalEnvio" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title label-black">{{pageTitle}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

                  <div class="row">
                        <div class="form-group col-12">
                            <label class="label-black">Nombre</label>
                            <input type="text" id="nombreSede_div" class="form-control" v-model="SedesArchivo.Nombre"/>
                        </div>
                  </div>
                  <div class="row col-12">
                        <div class="form-group form-check">
                            <input type="checkbox" id="ActivoSede_div" class="form-check-input" v-model="SedesArchivo.Activo"/>
                            <label class="label-black">  Activo</label>
                        </div>
                  </div>       
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="botonCancelar" >Cancelar</button>
          <button type="button" class="btn btn-custom" id="botonAceptar" >Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'

export default {
    data(){
        return{
            SedesArchivo: {
                SedeArchivoId: null,
                Nombre: "",
                Activo: false
            }
        }
    },
    props:  {
        sede: {
            type: Number,
            default: 0
        }
    },
    computed:{
        pageTitle(){
            if(this.sede != null && this.sede != undefined && this.sede >0)
            {return "EDICIÓN DE UNA SEDE DEL ARCHIVO "} else {return "NUEVA SEDE DEL ARCHIVO"}
            
        }
    },
    methods: {
        Mostrar: function () {
        $('#modalEnvio').modal('show');
        $('#botonCancelar').unbind('click').click(this.ModalClose);
        $('#closeModal').unbind('click').click(this.ModalClose);
        $('#botonAceptar').unbind('click').click(this.ModificarSede);
        },
        ModalClose: function(){
            $('#modalEnvio').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', false);
        },
        ObtenerSede(){
            var peticion = {
                "SedeArchivoId": this.sede
            };
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.ObtenerSede, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                if (respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                }
                else
                {
                    this.SedesArchivo = respuesta.data.GetSedeArchivo;
                    comun.SeEstaCargandoInformacion(false);

                }
                comun.SeEstaCargandoInformacion(false);
                
            })
            .catch(e=> {
                console.log("No Hay Respuesta del Servidor", e);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
        },
        ModificarSede(){
            var peticion = {
                "SedesArchivo" : {
                "SedeArchivoId": this.SedesArchivo.SedeArchivoId,
                "Nombre": this.SedesArchivo.Nombre,
                "Activo": this.SedesArchivo.Activo
                }
            };
            
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.GuardarSedeArchivo, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                if (respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                }
                else
                {
                    var mensaje ="";
                    if (this.SedesArchivo.SedeArchivoId > 0)
                    {
                        mensaje ="Se modificado la sede de Resguardo del Archivo Judicial.";
                    }
                    else
                    {
                        mensaje ="Se ha agregado una nueva sede de Resguardo del Archivo Judicial.";
                    }
                    comun.mensajeDeAlerta(mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                    this.ModalClose();
                }
                comun.SeEstaCargandoInformacion(false);
                
            })
            .catch(e=> {
                console.log("No Hay Respuesta del Servidor", e);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });

        }
    },
    mounted(){
        this.Mostrar();
        if(this.sede > 0)
        {
            this.ObtenerSede();
        }
    }
}
</script>
<style scoped>
    .thead-custom {
        background-color: #004746;
        color: white;
    }
    .modal-content {
        background-color:  #7e7f74;
    }
    .modal-header {
        background-color:  #007573;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/AddEditSede.vue